module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/mask/2-90fcfce00f09b8f7a555d76bfa66ccb5.jpg";